module.exports = __webpack_public_path__ + "img/public/SiteIcons/NoreservationIocn.svg?cec11acc";